export function getParamsFromSearch(search: string) {
  const urlParams = new URLSearchParams(search);
  return Object.fromEntries(urlParams);
}
